/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Csv_ButtonInputs */



/**
* | output |
* | --- |
* | "Import CSV" |
*
* @param {Team_Manager_Import_Csv_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_csv_button = /** @type {((inputs?: Team_Manager_Import_Csv_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Csv_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer un CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("CSV importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入 CSV")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSV を読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV इंपोर्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar CSV")
	return /** @type {LocalizedString} */ ("Import CSV")
});